import { render, staticRenderFns } from "./ResponsiveBannerDouble.vue?vue&type=template&id=a925e784&scoped=true&"
import script from "./ResponsiveBannerDouble.vue?vue&type=script&lang=js&"
export * from "./ResponsiveBannerDouble.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveBannerDouble.vue?vue&type=style&index=0&id=a925e784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a925e784",
  null
  
)

export default component.exports